<template>
    <div>
        <v-card @click="openDetails(club.container_id)" tile class="my-7 mx-3" v-for="club in clubs" elevation="10" :key="club.container_id">

            <v-img class="elevation-5 bg-cover" :height="coverHeight" :src="club.cover">

                <template v-slot:placeholder>
                    <v-progress-linear color="black" height="2" indeterminate></v-progress-linear>
                </template>

            </v-img>

            <div class="pb-0 mb-0 text-center" :style="style">
                <v-avatar color="#f7f7f7" :size="logoSize" class="elevation-8 border">
                    <v-img class="pa-2" :alt="club.name"
                           :src="club.logo">
                        <template v-slot:placeholder>
                            <v-progress-circular class="my-auto mx-auto" width="2" indeterminate></v-progress-circular>
                        </template>
                    </v-img>
                </v-avatar>
                <h3 class="pt-2">{{club.name}}</h3>
                <p class="pb-3" v-if="!showInfo">{{club.province}}</p>
            </div>

            <v-container v-if="showInfo" class="pb-0 mb-0 text-center">
                <v-row>
                    <v-col>
                        <v-icon size="20">mdi-account-group</v-icon>
                        <span class="d-block font-weight-light">Membri<br><strong>{{club.members}}</strong></span>
                    </v-col>
                    <v-divider vertical></v-divider>
                    <v-col>
                        <v-icon size="20">mdi-map-search</v-icon>
                        <span class="d-block font-weight-light">Provincia di<br><strong>{{club.province}}</strong></span>
                    </v-col>
                    <v-divider vertical></v-divider>
                    <v-col>
                        <v-icon size="20">mdi-target-variant</v-icon>
                        <span class="d-block font-weight-light">Distanza<br><strong>{{club.distance}} Km</strong></span>
                    </v-col>
                </v-row>
            </v-container>

        </v-card>
    </div>
</template>

<script>
    export default {
        name: "clubSheet",
        props: {
            clubs: {
                type: Object | Array,
                require: true
            },
            showInfo: {
                type: Boolean,
                default: true
            },
            logoSize: {
                type: Number,
                default: 100
            },
            coverHeight: {
                type: Number,
                default: 120
            }
        },
        computed: {
            style() {
                return 'margin-top: -' + (this.logoSize / 2) + 'px !important';
            }
        },
        methods: {
            openDetails(id) {
                this.$emit('openDetails',id);
            }
        }
    }
</script>

<style scoped>
    .bg-cover {
        background-image: url('https://italiasoftair.it/images/assets/cover-default.jpg');
        background-position: center center;
        background-size: cover;
    }
</style>